export default {"src":"/_next/static/media/logo-11.09e69788.svg","height":38,"width":56,"blurWidth":0,"blurHeight":0};